var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"BomInfoTable",attrs:{"paging":"","pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"columns":_vm.bomInfoCols,"rows":_vm.rows,"excel":_vm.isButton_(_vm.scrId, 'EX'),"stripe":false,"selection":false,"customExcel":_vm.excelFunc,"fit":"fit","creatable":""},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }